import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/* Motion-wrapped tag is selected from a static map so the component reference is stable */
const MOTION_TAGS = {
    div: motion.div,
    section: motion.section,
    article: motion.article,
    span: motion.span,
    li: motion.li,
    ul: motion.ul,
    nav: motion.nav,
    a: motion.a,
    button: motion.button,
    header: motion.header,
    footer: motion.footer,
    aside: motion.aside,
    main: motion.main,
};

/**
 * Reusable glassmorphism surface card.
 * Optional accent color border-glow + hover lift.
 */
export const GlassCard = ({
    children,
    accentColor = null,
    className = "",
    hoverLift = true,
    as = "div",
    style = {},
    ...rest
}) => {
    const reduce = useReducedMotion();
    const accentStyle = accentColor
        ? {
              boxShadow: `0 0 0 1px ${accentColor}30, 0 8px 32px ${accentColor}25`,
          }
        : {};

    const MotionTag = MOTION_TAGS[as] || motion.div;

    return (
        <MotionTag
            whileHover={
                hoverLift && !reduce
                    ? {
                          y: -4,
                          boxShadow:
                              "0 16px 48px rgba(139, 92, 246, 0.18), 0 0 0 1px rgba(255,255,255,0.12)",
                      }
                    : {}
            }
            transition={{ duration: 0.25, ease: "easeOut" }}
            className={`vfs-glass relative ${className}`}
            style={{ ...accentStyle, ...style }}
            {...rest}
        >
            {children}
        </MotionTag>
    );
};

export default GlassCard;
